;(function ($) {
	function stop_prop(e) {
		if (e && e.stopPropagation) e.stopPropagation();
		if (e && e.preventDefault) e.preventDefault();
		return false;
	}

	function insert_quicklink(e) {
		var path = $(this).attr('data-path'),
			$target = $(this).closest('.sui-form-field').find('textarea'),
			paths = $target.val().split("\n");
		paths.push(path);
		$target.val($.trim(paths.join("\n")));
		return stop_prop(e);
	}

	function gather_files() {
		return $('.shipper-file-exclusions textarea')
			.val().split("\n");
	}

	function gather_database() {
		var $selected = $('.sui-tree [aria-selected="true"] [data-table]'),
			sel = [];

		$selected.each(function () {
			sel.push($(this).attr('data-table'));
		});

		return sel;
	}

	function gather_advanced() {
		var $els = $('.sui-checkbox-stacked :checkbox'),
			opts = [];
		$els.each(function () {
			if (!$(this).is(':checked')) return true;
			opts.push($(this).attr('name'));
		});
		return opts;
	}

	function gather_meta() {
		var $modal = get_modal('meta');
		return {
			name: $modal.find('input[name="package-name"]').val(),
			password: $modal.attr('data-password'),
			_wpnonce: $modal.find('input[name="shipper-create-package"]').val()
		};
	}

	function start_preflight(e) {
		// colse any open modal and trigger preflight event
		SUI.closeModal();
		$(document).trigger('shipper-package-preflight');

		return stop_prop(e);
	}

	function gather_all_settings(e) {
		send_request('create', _.extend(
			gather_meta(),
			{'exclude_files': gather_files()},
			{'exclude_tables': gather_database()},
			{'exclude_extra': gather_advanced()}
		)).done(start_preflight);
		return stop_prop(e);
	}

	function send_request(action, obj) {
		obj = obj || {};
		obj.action = 'shipper_packages_meta_' + action;
		return $.post(ajaxurl, obj);
	}

	function handle_package_rewrite(e) {
		var nonce = $('input[name="shipper-reset-package"]').val();
		send_request('reset', {_wpnonce: nonce})
			.done(show_package_meta);
		return stop_prop(e);
	}

	function show_modal( id, replace_modal ) {
		var replace_modal    = replace_modal ? true : false;
		var modal_id          = get_modal_id( id );
		var focus_after_closed = this;
		var focus_when_open    = undefined;
		var has_overlay_mask   = false;
		var modal            = get_modal( id );

		SUI[ replace_modal ? 'replaceModal' : 'openModal' ]( modal_id, focus_after_closed, focus_when_open, has_overlay_mask )

	    return modal;
	}

	function get_modal_id( id ) {
		return 'shipper-package-create-' + id;
	}

	function get_modal( id ) {
		return $( '#' + get_modal_id( id ) );
	}

	function show_package_settings(e) {
		show_modal('settings', true )
			.find('.shipper-next')
			.off('click')
			.on('click', gather_all_settings).end()
			.find('.shipper-previous')
			.off('click')
			.on( 'click', function(e) {
				show_package_meta(e, true)
			} );

		return stop_prop(e);
	}

	function set_password_and_show_package_settings(e) {
		var $modal = get_modal('meta');
		var	$password = $modal.find('[data-state]:visible input[name="installer-password"]');

		$modal.attr('data-password', $password.val());
		$modal.find('.shipper-next').attr('disabled', 'disabled');

		var site_id = $modal.find('select[name="site_id"]').val();
		var network_type = $modal.find('input[name="network_type"]');

		if ( network_type && network_type.length ) {
			network_type.each( function(key, element) {
				if ( $(element).is(':checked') ) {
					network_type = $(element).val();
				}
			})
		} else {
			network_type = undefined;
		}

		$.post(ajaxurl, {
			_wpnonce: $modal.find('#shipper-refreshdbt-nonce').val(),
			site_id: site_id,
			network_type: network_type,
			action: 'shipper_packages_meta_refresh_db_tree'
		}, function (html) {
			$modal.find('.shipper-next').prop( 'disabled', false );
			var el = $(html);
			var $settings_modal = get_modal('settings');
			$settings_modal.find('.sui-tree').replaceWith(el);
			SUI.suiTree( $settings_modal.find('.sui-tree'), true );
			return show_package_settings(e);
		})
	}

	function show_package_meta(e, replace) {
		var modal = show_modal('meta', replace);
		var all_sites = modal.find('.sui-select#all-sites');
		var nonce = all_sites.data('nonce');
		var endpoint = ajaxurl + '?action=shipper_packages_meta_search_sub_site&_wpnonce=' + nonce;

		$(all_sites).SUIselect2({
			dropdownCssClass: $('.sui-color-accessible')[0] ? 'sui-select-dropdown sui-color-accessible' : 'sui-select-dropdown',
			dropdownParent: $(modal),
			ajax: {
				url: endpoint,
				delay: 750,
				dataType: 'json',
				cache: true,
				data: function( params ) {
					var query = {
						search: params.term
					}

					return query;
				},
				processResults: function( response ) {
					if ( ! response || ! response.data ) {
						return {
							results: {}
						}
					}

					var options = response.data.map(function(option) {
						return {
							id: option.site_id,
							text: option.site_url,
						}
					});

					return {
						results: options
					}
				},
			}
		});

		modal
		.attr('data-password', '')
		.find('.shipper-next')
		.off('click')
		.on('click', set_password_and_show_package_settings);

		return stop_prop(e);
	}

	function show_package_rewrite_confirm() {
		show_modal('confirm')
			.find('.shipper-next')
			.off('click')
			.on('click', handle_package_rewrite);
	}

	function create_new_package(e) {
		if ($('.shipper-packages-migration').is('.shipper-has-packages')) {
			show_package_rewrite_confirm();
		} else show_package_meta();

		return stop_prop(e);
	}

	function delete_package(e) {
		var nonce = $('input[name="shipper-reset-package"]').val();
		send_request('reset', {_wpnonce: nonce})
			.done(function () {
				window.location.reload();
			});
		return stop_prop(e);
	}

	function download_package(e) {
		var nonce = $(this).closest('.shipper-download')
			.find(':hidden[name="_wpnonce"]').val();
		window.location = ajaxurl +
			'?action=shipper_packages_meta_download_package&_wpnonce=' +
			nonce;
		return stop_prop(e);
	}

	function download_installer(e) {
		var nonce = $(this).closest('.shipper-download')
			.find(':hidden[name="_wpnonce"]').val();
		window.location = ajaxurl +
			'?action=shipper_packages_meta_download_installer&_wpnonce=' +
			nonce;
		console.log( ajaxurl +
			'?action=shipper_packages_meta_download_installer&_wpnonce=' +
			nonce);
		return stop_prop(e);
	}

	function init() {
		if (!$('.shipper-packages-migration-main').length) {
			return false;
		}
		if ((window._shipper || {}).navbar) {
			window._shipper.navbar('.shipper-page-packages');
		}
		$(document).on(
			'click',
			'.shipper-new-package',
			create_new_package
		);
		$(document).on(
			'click',
			'.shipper-delete',
			delete_package
		);
		$(document).on(
			'click',
			'.shipper-quicklinks a[data-path]',
			insert_quicklink
		);
		$(document).on(
			'click',
			'#shipper-package-create .shipper-cancel, #shipper-delete-modal .shipper-cancel, #shipper-package-create .sui-dialog-close',
			function (e) {
				SUI.closeModal();
				return stop_prop(e);
			}
		);

		$(document).on(
			'click',
			'.shipper-download-item.archive',
			download_package
		);

		$(document).on(
			'click',
			'.shipper-download-item.installer',
			download_installer
		);

		$( window ).on(
			'load',
			function() {
				var url = document.location;

				if ( url.search.includes( '?page=shipper-packages&start=true' ) ) {
					create_new_package();
				}
			}
		);
	}

	$(init);

})(jQuery);
